import styled from 'styled-components';

export const BundleSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${(props) => (props.lactoMamaCategory ? '' : 'center')};
  width: 100%;
  padding: 0 12px;
  // overflow: auto;

  &::-webkit-scrollbar {
    display: none;
  }

  padding-top: ${(props) => (props.isFertilityProduct ? '0' : '0')};
  overflow: ${(props) => (props.lactoMamaCategory ? 'auto' : '')};
`;
export const BundleWrapper = styled.div`
  margin-bottom: 11px;
  scroll-behavior: smooth;
  margin-left: ${(props) => (props.lactoMamaCategory ? '0' : '-12px')};
  margin-right: ${(props) => (props.lactoMamaCategory ? '0' : '-12px')};

  .heading {
    padding: 8px 12px 16px;
    font-size: 15px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.87);
    text-align: ${(props) => (props.lactoMamaCategory ? 'center' : 'left')};
  }

  @media (max-width: 720px) {
    margin-top: 0;
    margin-bottom: 10px;
  }
  @media (min-width: 720px) {
    .heading {
      ${(props) =>
        props.lactoMamaCategory ? 'font-size: 18px;' : 'font-size: 15px;'}
    }
  }
`;
export const LactomamaPackOuter = styled.div`
  border-radius: 8px;
  // min-width: 22%;
  border: ${(props) =>
    props.selected ? 'solid 2px #ef4e5e' : 'solid 1px #bec4c4'};
    overflow: hidden;
  @media (max-width: 720px) {
    flex-basis: 33.3%;
  }
  @media (min-width: 720px) {
    flex-basis: 50%;
  }

  &.lowOpacity {
    opacity: 0.5;
  }

  margin-right: ${(props) => (props.lactoMamaCategory ? '6px' : '11px')};

  &:last-child {
    margin-right: 10px;
  }

  .imageOuter {
    position: relative;
    padding-top: 100%;
    width: 100%;
    aspect-ratio: 1;
    @media (min-width: 720px) {
      ${(props) =>
        props.lactoMamaCategory &&
        `
                min-height: 90px;
                min-width: 90px;
                max-width: 104px;
                max-height: 104px;
                margin: 16px 16px 1.4px 12px;
                border-radius: 7.5px;
                padding: 0;

                .image {
                    border-radius: 7.5px;
                }
            `}
    }
  }

  .extraPadding {
    padding: 8px;
  }

  position: relative;
  z-index: 2;
`;

export const PackInfo = styled.div`
  width: 100%;
  border-radius:7.5px;
  justify-content: center;
  align-items: center;
  @media (min-width: 720px) {
    .gridLayout {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }

    .gridInner {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: left;
    }
  }

  img {
    margin-right: 8px;
  }

  .variantFeature {
    display: flex;
    list-style: none;
    opacity: 0.9;
    font-size: clamp(11px, 2vw, 14px);
    padding: 2px;
    font-weight: 400;
    font-size: 12px;
    color: #848484;
    justify-content: center;
    align-items: center;
    @media (min-width: 720px) {
        .gridLayout {
            display: grid;
            grid-template-columns: 1fr 1fr;
        }

        .gridInner {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: left;
        }
        padding-bottom: ${(props) => (props.botPadding ? '12px' : '')};
    }

    img {
        margin-right: 8px;
    }

    .variantFeature {
        display: flex;
        list-style: none;
        opacity: 0.9;
        font-size: clamp(11px, 2vw, 14px);
        padding: 2px;
        font-weight: 400;
        font-size: 12px;
        color: #848484;
        justify-content: center;
        align-items: center;
    }
`;
export const BundleContainer = styled.div`
  border-radius: 5px;
  // min-width: 22%;
  border: ${(props) =>
    props.selected ? 'solid 1px #ef4e5e' : 'solid 1px #bec4c4'};
  @media (max-width: 720px) {
    flex-basis: ${(props) =>
      props.stretchMarks ? '50%' : props.isFertilityProduct ? '' : '33.33%'};
  }
  @media (min-width: 720px) {
    width: ${(props) => (props.isFertilityProduct ? '24.8%' : '28%')};
  }

  &.lowOpacity {
    opacity: 0.5;
  }

  margin-right: ${(props) => (props.lactoMamaCategory ? '6px' : '11px')};

  &:last-child {
    margin-right: 0px;
  }

  .imageOuter {
    position: relative;
    padding-top: 100%;
    width: 100%;
    aspect-ratio: 1;
    @media (min-width: 720px) {
      ${(props) =>
        props.lactoMamaCategory &&
        `
                min-height: 90px;
                min-width: 90px;
                max-width: 104px;
                max-height: 104px;
                margin: 16px 16px 1.4px 12px;
                border-radius: 7.5px;
                padding: 0;

                .image {
                    border-radius: 7.5px;
                }
            `}
    }
  }

  .extraPadding {
    padding: 8px;
  }

  position: relative;
  z-index: 2;
  // @media (max-width: 720px) {
  //   min-width: ${(props) => (props.lactoMamaCategory ? '150px' : '')};
  // }
  // min-width: ${(props) => (props.lactoMamaCategory ? '250px' : '')};
`;
export const VariantFeature = styled.div`
  display: flex;
  list-style: none;
  opacity: 0.9;
  font-size: clamp(11px, 2vw, 14px);
  padding: 2px;
  font-weight: 400;
  font-size: 12px;
  color: #848484;
  justify-content: center;
  align-items: center;
  @media (min-width: 720px) {
    justify-content: left;
    margin: 12px 0 12px 4px;
    display: flex;
    list-style: none;
    opacity: 0.9;
    font-size: clamp(11px, 2vw, 14px);
    font-weight: 400;
    font-size: 12px;
    color: #848484;
    align-items: left;
  }

  li {
    margin-right: 0px !important;
  }
`;

export const PackPrice = styled.div`
  margin-left: auto;
  padding-top: 5px;

  .perMonth {
    font-size: 12px;
    text-align: right;
    color: #63b0a8;
  }

  p {
    color: #6e6e6e;
    font-size: 14px;
  }
`;
export const PPUText = styled.div`
  margin-left: auto;
  margin-top: 4px;
  margin-bottom: -2px;

  font-family: 'Montserrat';

  p {
    font-size: 13px;
    color: #6e6e6e;
  }

  b {
    font-size: 14px;
  }
`;
export const PackDetails = styled.div`
  padding: 10px 10px 0;

  ul {
    list-style: inherit;

    li {
      ::marker {
        color: #63b0a8;
      }

      font-size: clamp(12px, 2vw, 14px);
      text-align: left;
      color: rgba(0, 0, 0, 0.8);
      padding-bottom: 4px;
      line-height: 16px;
    }
  }
`;

export const TitleWrapper = styled.div`
  background: ${(props) => (props.selected ? 'rgb(255,250,250)' : '#fafafa')};
  padding: 10px;
  border-radius: 4px;
  border-bottom: solid 1px #ececec;

  p {
    font-size: 12px;
    font-weight: 600;
    color: rgb(0, 0, 0, 0.87);
  }

  div {
    font-size: 12px;
    font-weight: 600;
    color: rgb(0, 0, 0, 0.67);
    margin-top: 5px;
  }
  .title {
    font-size: 12px;
`;

export const DiscountStyle = styled.span`
  font-size: clamp(12px, 2vw, 14px);
  font-weight: 600;
  color: #63b0a9;
`;

export const StrikePrice = styled.span`
  color: hsl(0deg 0% 0% / 40%);
  font-size: ${(props) => (props.isUAE ? '12px' : '13px')};
  text-decoration: line-through;
  font-weight: 500;
`;

export const Price = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
`;

export const VariantTitle = styled.div`
  background: ${(props) => (props.selected ? '#FEFAFA' : '#fafafa')};
  padding: 8px;
  border-bottom: 1px solid #dadada;
  display: flex;
  align-items: center;
  border-radius: 4px;
  column-gap: 12px;
  @media (min-width: 768px) {
    padding: ${(props) => (props.isFertilityProduct ? '10px' : '8px')};
  }

  .radioBtn {
    width: 14px;
    display: block;
    height: 14px;
    outline: 2px solid #6e6e6e80;
    border-radius: 50%;
    position: relative;

    &.checked {
      height: 12px;
      width: 12px;
      outline: 2px solid #ef4e5e;
      outline-offset: 2px;
      background: #ef4e5e;
    }
  }

  p {
    font-weight: 600;
    opacity: 0.87;
    color: #000;
    font-size: 12px;
  }
`;

export const VariantData = styled.div`
  padding: 7px;
  position: relative;

  li {
    list-style: none;
    opacity: 0.9;
    font-size: clamp(11px, 2vw, 14px);
    padding: 1px 0;
    font-weight: 400;
  }

  .mrpPrice {
    margin: 12px 0 6px;
    font-weight: 600;
    font-size: clamp(14px, 2vw, 16px);
  }

  .priceInfo {
    display: flex;
    // column-gap: 3px;
  }

  .inclusive {
    color: #6e6e6e;
    font-weight: 400;
    font-size: 10px;
    padding: 2px 0;
  }

  .pricePerUnit {
    font-size: clamp(11px, 2vw, 14px);
    font-weight: 500;
    margin: 4px 0;
  }
`;

export const VariantTag = styled.div`
  background-color: #fcecdf;
  padding: 6px 14px 6px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  overflow: hidden;

  p {
    font-size: 10px;
    font-weight: 600;
    color: #805020;
  }

  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 6px;

  img {
    width: 20px;
    height: 20px;
  }

  @media (min-width: 720px) {
    margin: 8px 0 0 0;
    padding: 2px 14px 2px;
  }
`;
